import { useMemo } from 'react';
import { format } from 'date-fns';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import { getCustomizeOpenStatus } from '../../../utils/campaignState';
import { onClickAddMore } from '../../../utils/subscriptions';
import OrderSummary from '../SharedComponents/OrderSummary/OrderSummary';
import Panel from '../SharedComponents/Panel/Panel';
import { getTotalQty } from '../SharedComponents/utils/helperFuncs';

const getOpenStatus = (boxData) => getCustomizeOpenStatus(boxData);

const ShipWithBoxPanel = ({
  subscriptions,
  displayShopNowBtn = true,
  sysdata,
  displaySeparator = true,
  subTotal,
  editCampaign,
}) => {
  const { boxData = {} } = sysdata;

  const nextShipmentBoxDate = useMemo(() => {
    if (!subscriptions || subscriptions.length === 0) return 'Processing';
    const dates = subscriptions
      .map((sub) => sub.nextRenewalDate)
      .filter(Boolean)
      .sort();
    const closestDate = dates[0] || null;
    return closestDate ? format(closestDate, 'MMMM d') : 'Processing';
  }, [subscriptions]);
  const panelName = 'Shipping With Box';
  const status = getOpenStatus(boxData);

  return (
    <div data-testid="ship-with-box-container">
      <Panel
        currentSale={''} // TODO: Get current sale from API
        sysdata={sysdata}
        panelItems={subscriptions}
        panelName={panelName}
        nextShipmentDate={nextShipmentBoxDate}
        sectionType="GO_WITH_BOX"
        displayShopNowBtn={displayShopNowBtn}
        displayOrderSummary
        status={status}
        displaySeparator={displaySeparator}
        isEditCampaignOpen={editCampaign?.userAccess}
        orderSummary={
          <OrderSummary
            title="Subscriptions"
            total={getTotalQty(subscriptions)}
            sum={subTotal}
            footnote="Total does not reflect credit applied."
            isRefillSection
            isFreeShipping
          />
        }
        addMore={
          <Button onClick={() => onClickAddMore()} width="100%">
            ADD MORE
          </Button>
        }
      />
    </div>
  );
};

ShipWithBoxPanel.propTypes = {
  subscriptions: arrayOf(object).isRequired,
  displayShopNowBtn: bool,
  sysdata: shape({
    boxData: shape({
      customizeCampaignState: shape({}).isRequired,
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }),
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
    isProspect: bool.isRequired,
  }).isRequired,
  displaySeparator: bool,
  subTotal: number.isRequired,
  editCampaign: shape({
    userAccess: bool,
  }),
};

export default ShipWithBoxPanel;
